import ProductDatasetSource from './ProductDatasetSource';

export default class ProductDataset {
	source: ProductDatasetSource;

	productRetrievedAt: Date | null;

	validFrom: Date | null;

	productUpdatedAt: Date | null;

	constructor(
		source: ProductDatasetSource,
		productRetrievedAt: Date | null,
		validFrom: Date | null,
		productUpdatedAt: Date | null
	) {
		this.source = source;
		this.productRetrievedAt = productRetrievedAt;
		this.validFrom = validFrom;
		this.productUpdatedAt = productUpdatedAt;
	}
}
